export function Footer() {
  return (
    <footer className="bg-black text-white py-8">
      <div className="container mx-auto px-4">
        {/* Social Media Icons */}
        <div className="flex justify-center space-x-6 mb-6">
          <a
            href="https://www.facebook.com/100212768536512"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-blue-500 transition-colors"
            aria-label="Facebook"
          >
            <svg
              className="w-8 h-8"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a
            href="https://www.instagram.com/goodspeedairport"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-pink-500 transition-colors"
            aria-label="Instagram"
          >
            <svg
              className="w-8 h-8"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-2.508 0-4.541-2.033-4.541-4.541s2.033-4.541 4.541-4.541 4.541 2.033 4.541 4.541-2.033 4.541-4.541 4.541zm7.089 0c-2.508 0-4.541-2.033-4.541-4.541s2.033-4.541 4.541-4.541 4.541 2.033 4.541 4.541-2.033 4.541-4.541 4.541z"/>
              <circle cx="12" cy="12" r="3.5"/>
              <circle cx="18.5" cy="5.5" r="1.5"/>
            </svg>
          </a>
        </div>

        {/* Copyright Text */}
        <div className="text-center text-gray-400 mb-4">
          <p>Copyright © 2024 Goodspeed Airport - All Rights Reserved.</p>
        </div>

        {/* Footer Links */}
        <div className="flex justify-center space-x-8 text-sm mb-6">
          <a
            href="/privacy-policy"
            className="text-gray-400 hover:text-white transition-colors uppercase tracking-wide"
          >
            Privacy Policy
          </a>
          <a
            href="/terms-and-conditions"
            className="text-gray-400 hover:text-white transition-colors uppercase tracking-wide"
          >
            Terms and Conditions
          </a>
        </div>

        {/* GoDaddy Attribution */}
        <div className="text-center text-gray-500 text-sm">
          <p>
            Powered by{' '}
            <a
              href="https://www.godaddy.com/websites/website-builder?isc=pwugc&utm_source=wsb&utm_medium=applications&utm_campaign=en-us_corp_applications_base"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-400 transition-colors"
            >
              GoDaddy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}